// Scale Captain Theme JS
(function(){
  'use strict';

  // Mobile nav
  var toggle=document.querySelector('.nav-toggle');
  var nav=document.querySelector('.main-nav');
  if(toggle&&nav)toggle.addEventListener('click',function(){nav.classList.toggle('open');});

  // Produkt: Varianten-Karten
  var picker=document.querySelector('[data-variant-picker]');
  if(picker){
    var priceEl=document.querySelector('[data-price]');
    var compareEl=document.querySelector('[data-compare-price]');
    var saveEl=document.querySelector('[data-save-badge]');
    var btn=document.querySelector('[data-add-btn]');
    function fmt(cents){
      return new Intl.NumberFormat('de-DE',{style:'currency',currency:picker.dataset.currency||'EUR'}).format(cents/100);
    }
    picker.addEventListener('change',function(e){
      var input=e.target.closest('input[name="id"]');
      if(!input)return;
      picker.querySelectorAll('.vcard').forEach(function(c){c.classList.toggle('selected',c.contains(input));});
      var p=parseInt(input.dataset.price,10);
      var cp=parseInt(input.dataset.compare||'0',10);
      if(priceEl)priceEl.textContent=fmt(p);
      var vsEl=document.querySelector('[data-vs-price]');
      if(vsEl)vsEl.textContent=fmt(p);
      if(compareEl){
        if(cp>p){compareEl.textContent=fmt(cp);compareEl.style.display='';}
        else compareEl.style.display='none';
      }
      if(saveEl){
        if(cp>p){saveEl.textContent='–'+Math.round((1-p/cp)*100)+'%';saveEl.style.display='';}
        else saveEl.style.display='none';
      }
      if(btn){
        var avail=input.dataset.available==='true';
        btn.disabled=!avail;
        btn.textContent=avail?(btn.dataset.label||'In den Warenkorb'):'Ausverkauft';
      }
    });
  }

  // Produkt: Galerie
  var mainImg=document.querySelector('[data-gallery-main] img');
  document.querySelectorAll('[data-thumb]').forEach(function(t){
    t.addEventListener('click',function(){
      if(mainImg){mainImg.src=t.dataset.src;mainImg.srcset='';if(t.dataset.zoom)mainImg.setAttribute('data-zoom',t.dataset.zoom);}
      document.querySelectorAll('[data-thumb]').forEach(function(x){x.classList.remove('active');});
      t.classList.add('active');
    });
  });

  // Warenkorb: Menge ±
  document.querySelectorAll('[data-qty]').forEach(function(box){
    var input=box.querySelector('input');
    box.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click',function(){
        var v=parseInt(input.value||'1',10)+(b.dataset.dir==='up'?1:-1);
        input.value=Math.max(0,v);
        input.form&&input.form.submit();
      });
    });
    input&&input.addEventListener('change',function(){input.form&&input.form.submit();});
  });
})();

// Lightbox für vergrößerbare Bilder
(function(){
  'use strict';
  document.addEventListener('click',function(e){
    var img=e.target.closest('.zoomable');
    if(!img)return;
    var box=document.createElement('div');
    box.className='lightbox';
    var big=document.createElement('img');
    big.src=img.getAttribute('data-zoom')||img.src;
    big.alt=img.alt||'';
    box.appendChild(big);
    document.body.appendChild(box);
    document.body.style.overflow='hidden';
    box.addEventListener('click',function(){box.remove();document.body.style.overflow='';});
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      var b=document.querySelector('.lightbox');
      if(b){b.remove();document.body.style.overflow='';}
    }
  });
})();
